/**
 * The app's one instance. Made on first use from the real store and `policyIndex`, so no app wires
 * it; nothing runs at module load. A test registers its own and restores the previous one.
 */
import store from "../redux-store";
import { createCapabilities, type Capabilities } from "./engine";
import { policyIndex } from "./policyIndex";
import { createStoreSources } from "./sources/store";

let instance: Capabilities | null = null;

export function capabilities(): Capabilities {
  instance ??= createCapabilities({ policies: policyIndex, sources: createStoreSources(store) });
  return instance;
}

/** returns the restore */
export function registerCapabilities(next: Capabilities): () => void {
  const previous = instance;
  instance = next;
  return () => {
    instance = previous;
  };
}
